<template>
  <div :class="['text-box', { readonly }]">
    <slot name="left"></slot>
    <input
      :class="['text', textClass]"
      :type="inputType"
      :value="value"
      @input="handleTextInput($event.target.value)"
      @change="handleTextChange"
      :placeholder="localizedText"
      :readonly="readonly"
      :maxlength="maxlength"
    >
    <slot name="right"></slot>
  </div>
</template>

<script>
import t from '@/plugins/i18n';

export default {
  name: 'TextBox',
  mixins: [t],

  props: {
    inputType: {
      type: String,
      default: 'text',
    },
    value: {
      type: String,
    },
    placeholder: {
      type: String,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: String,
      default: '',
    },
    textClass: {
      type: String,
      default: '',
    },
  },

  model: {
    prop: 'value',
    event: 'change-value',
  },

  computed: {
    localizedText() {
      return this.placeholder || this.t('入力してください');
    },
  },

  methods: {
    handleTextInput(text) {
      this.$emit('change-value', text);
      this.$emit('handleTextInput', text);
    },
    handleTextChange() {
      this.$emit('handleTextChange');
    },
    inputData(val) {
      this.$emit('change-value', val);
    },
  },
};
</script>

<style lang="scss" scoped>
.text-box{
  display: flex;
  width: 100%;
  padding: 10px;
  background-color: $white;
  border: solid 1px #787878;
  border-radius: 5px;
  &.readonly{
    background-color: $disabledGray;
  }
  .text{
    width: 100%;
    flex: 1 1 100%;
    font-family: $notoSans;
    font-size: 14px;
    line-height: 20px;
    outline: none;
    &::placeholder{
      color: #AAA;
    }
  }
}
.one_code {
  text-align:center;
  font-size: 24px!important;
  -moz-appearance:textfield;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
@media screen and  (max-width: $tabletWidth) {
  .text-box {
    padding: 5px 10px !important;
    .text {
      line-height: 10px;
    }
  }
  .one_code {
    font-size: 16px!important;
  }
}
@media screen and (max-width: $mobileWidth) {
  .text-box{
    .text{
      font-size: small;
    }
  }
}
</style>
